/**
 * Toolbox — widget-first (2.1).
 * Panels: pages/modules/toolbox/panels.tsx (+ sysupdate v registry.toolbox).
 * Catalog: module-ui-catalog → stejné taby na /infra/nodes/:id.
 * ?tab= zachováno (ModulePage odkazy na backup atd.).
 */
import { useSearchParams } from 'react-router-dom';
import { requireModuleUi } from '../../widgets/module-ui-catalog';
import { ModuleWorkspace } from './ModuleWorkspace';

const DEF = requireModuleUi('toolbox');

export default function ToolboxPage() {
  const [searchParams] = useSearchParams();
  const defaultTab = searchParams.get('tab') ?? 'health';
  return <ModuleWorkspace def={DEF} hideHeader defaultTab={defaultTab} />;
}
